import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload"
import { useOrderImportCSV } from "../../../api/queries/useOrderImportCSV"
import { Button } from "primereact/button"
import { SyntheticEvent, useState } from "react"
import { useNavigate } from "react-router"

export const OrderImportCSV = () => {
  const navigate = useNavigate()
  const orderImportCSV = useOrderImportCSV()

  const [file, setFile] = useState<string>("")
  const [name, setName] = useState<string>("")

  const onFileUpload = async (event: FileUploadHandlerParam) => {
    const reader = new FileReader()

    reader.onload = () => {
      setFile(reader.result as string)
    }

    setName(event.files[0].name)
    reader.readAsDataURL(event.files[0])
  }

  const onSubmit = async (event: SyntheticEvent) => {
    event.preventDefault()

    await orderImportCSV.mutateAsync({ file })

    navigate("/orders")
  }

  return (
    <div className={"col-12"}>
      <form onSubmit={onSubmit}>
        <div className={"p-fluid"}>
          <div className={"border-round-top flex block-title block-title_blue align-items-center px-3"}>
            CSV import objednávek
          </div>

          <div className={"border-solid border-1 border-300 px-3 pt-4 mb-6"}>
            <div className={"grid"}>
              <div className={"field col-12 md:col-4"}>
                <span className={"p-float-label"}>
                  <FileUpload mode="basic" name="file" customUpload={true} uploadHandler={onFileUpload}
                    accept="text/csv" auto={true} chooseLabel={name || "Vybrat"}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={`md:flex`}>
          <span className={"flex-1 text-right"}>
            <Button type={"submit"} label={"Odeslat"}
              className={"p-button p-button-sm p-button-success"}
              disabled={orderImportCSV.isLoading || !file}
              icon={orderImportCSV.isLoading ? "pi pi-spinner pi-spin" : "pi pi-upload"} />
          </span>
        </div>
      </form>
    </div>
  )
}
